/**
 * Which fenced blocks in an assistant reply are components rather than code.
 *
 * Kept in one place because ReactMarkdown asks TWO renderers about the same fence: `code` (which swaps in the
 * component) and `pre` (which wraps it). They have to agree, and when they did not the widgets rendered
 * *inside* `<Box as="pre">` and inherited everything a preformatted block implies — `white-space: pre` so the
 * question could not wrap, a monospace font on the buttons, a grey background behind the card, and
 * `overflowX: auto` so the whole thing scrolled sideways out of the chat column instead of reflowing.
 *
 * A widget is interactive UI. It is not preformatted text and must not be treated as any.
 */

/** `widget:confirm`, `widget:select`, … — the type is captured for `ChatWidget`. */
export const WIDGET_FENCE = /language-widget:(\w+)/;

/** The inline chart reference card. */
export const CHART_FENCE = /language-chart:ref/;

/**
 * Does this `pre`'s content resolve to a component?
 *
 * Reads the className off the child `code` element, because that is where ReactMarkdown puts the fence's
 * language — `pre` itself carries none. Uses `Children.toArray` rather than assuming a single child: a
 * malformed fence can yield several, and `children.props` would be undefined on an array.
 */
export function isComponentFence(children) {
  const list = Array.isArray(children) ? children : [children];
  return list.some((child) => {
    const className = child?.props?.className ?? "";
    return WIDGET_FENCE.test(className) || CHART_FENCE.test(className);
  });
}
